import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import axios from 'axios';
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, Button } from 'react-bootstrap';
import CloseBatch from './CloseBatch';
import UpdateDevice from './UpdateDevice';
import { env } from './const';
import { headers } from '../utils/common';
import { useHistory, Link, withRouter } from 'react-router-dom';
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { getUserName, getRole } from '../utils/common';
import { Role } from '../utils/role';
import MaterialIcon, { colorPalette } from 'material-icons-react';
import AddNewDevice from "./AddNewDevice";
import {Tabs, Tab} from 'react-bootstrap-tabs';
import AssignDevices from "./AssignDevices";
import { useTranslation } from 'react-i18next';
const DeviceManagement = () => {
  const { t } = useTranslation(['device', 'common']);
    const [role, setRole] = useState(getRole());
    const columns = [
        {
            name: t('device:list.imei'),
            selector: "imeiNumber",
            sortable: true,
            minWidth: '150px'
        },
        {
            name: t('common:entity.farmer'),
            selector: "farmerName",
            sortable: true,
            minWidth: '250px',
            cell: row => <>
            {row.farmerName==''?<i>-NA-</i>:row.farmerName}
            </>
        },
        
        {
            name: t('device:list.lastUsedInBarn'),
            selector: "farm",
            sortable: true,
            minWidth: '150px',
            cell: row => <>
            {row.farm==''?<i>-NA-</i>:row.farm}
            </>
        },
        {
            name: t('common:entity.batch'),
            selector: "batch",
            sortable: true,
            cell: row => <>
            {row.batch==''?<i>-NA-</i>:row.batch}
            </>
        },
        {
            name: t('common:fields.status'),
            sortable: true,
            maxWidth: '100px',
            cell: row => <>
            {row.status == 'Active'?
            <div>
                <span style={{color: '#28a745'}}>{row.status}</span>
            </div>
            :
            <div>
                <span style={{color: '#dc3545'}}>{row.status}</span>
            </div>
            } </>,
        },
        {
            name: t('device:list.addedDate'),
            selector: "createdDate",
            sortable: true
        },
    ];
    const [displayData, setDisplayData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

   
    const onSearch = (event)=>{
        setSearchTerm(event.target.value)
    }
    const [headersobj] = useState(headers());
    const [selectedRows, setSelectedrows] = useState([]);
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [devicesList, setDeviceList] = useState([]);
    
    const closeAddPopup = () => {
        setShowAddPopup(false);
        // setshowStopBatch(false);
        // setshowUpdateBatch(false);
    }
    const getDevices = ()=>{
        axios.get(env.produrl+'/mydevices/', { headers: headersobj}
        ).then(res=>{
            setDeviceList(res.data.data);
            setDisplayData(res.data.data);
        }).catch((err) =>{
            console.log(err);
        });
    }
    useEffect(() => {
        getDevices();
    }, [])
    const handleSelectedRows = (state)=>{
        setSelectedrows(state.selectedRows)
    }
    const deactivateDevice = ()=>{
        if(selectedRows.length==1) {
            //alert(JSON.stringify(selectedRows))
            const data = {
                imeinumber: selectedRows[0].imeiNumber
            }
            const userConfirmed = window.confirm('Are you sure you want to proceed?');
            if(!userConfirmed) {
                return;
            }
            axios.post(env.produrl + '/mydevices/deactivate', data, { headers: headersobj })
            .then(res => {
              alert(res.data.message);
              getDevices();
            }).catch((err) => {
                alert(err.response.data.message);
            });
        } else if(selectedRows.length>1) {
            alert(t('device:list.selectOneAtATime'));
        } 
        else {
            alert(t('device:list.selectADevice'));
        }
    }
    useEffect(() => {
        if(searchTerm !=='' && searchTerm.length >2) {
          
            try{
            const filteredData = devicesList.filter(item => {
                const imeiNumber = item.imeiNumber || "";
                const farm = item.farm || "";
                const farmerName = item.farmerName || "";
            
                return farmerName.toLowerCase().includes(searchTerm.toLowerCase()) || imeiNumber.includes(searchTerm) || farm.toLowerCase().includes(searchTerm.toLowerCase());
            });
          
                setDisplayData(filteredData)
            } catch(err) {
                alert(err)
                setDisplayData(devicesList)
            }
        } else {
            setDisplayData(devicesList)
        }
    }, [searchTerm, devicesList, displayData]); // Dependency on searchTerm and originalData
    
    const BootyCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => (
        <div className="custom-control custom-checkbox">
            <input
                type="checkbox"
                className="custom-control-input"
                ref={ref}   
                {...rest}
            />
            <label className="custom-control-label" onClick={onClick} />
        </div>
    ));
    return (

        <div className="batchOperations">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('device:list.manageDevices')}</h2>
                </div>
            </div>
            <div className="card">
                <div class="card-body">
                <Tabs activeHeaderStyle={{background:'transparent'}}>
                    <Tab label={t('device:list.listOfDevices')}>
                    <div className="row">
                        <div className="col-md-4">
                            <form>
                                <div class="input-group">
                                    <input type="search" className="form-control form-control-sm" 
                                    placeholder={t('device:list.searchPlaceholder')} 
                                    //value={searchTerm}
                                    onKeyUp={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <div class="input-group-append">
                                        <div type="submit" className="btn btn-sm btn-default">
                                            <i class="fa fa-search"></i>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br></br>
                        {/* <div className="col-md-8">
                            <ul class="controls">
                                <li><button onClick={()=>setShowAddPopup(true)}  type="button" class="btn btn-block btn-outline-success btn-sm">
                                    Add Device</button></li>
                                <li><button onClick={()=>deactivateDevice()} type="button" class="btn btn-block btn-outline-danger btn-sm">{t('device:list.deactivate')}</button></li>
                            </ul>
                        </div> */}
                    </div>
                    <DataTable
                        columns={columns}
                        data={displayData}
                        defaultSortField="batchID"
                        pagination
                        selectableRows
                        selectableRowsComponent={BootyCheckbox}
                        onSelectedRowsChange={handleSelectedRows}
                        dense
                        selectableRowsHighlight='true'
                        compact
                        highlightOnHover='true'
                        striped
                    />
                    </Tab>
                    {role==Role.Admin?
                    
                     <Tab label={t('device:list.addRemove')}>
                        <AssignDevices></AssignDevices>
                    </Tab>
                    
                    :<></>}
                </Tabs>
                  
                </div>
            </div>
            <AddNewDevice onChange={()=>closeAddPopup()} show={showAddPopup}></AddNewDevice>
        </div>

    );
}

export default DeviceManagement;